export enum ClientApplicationStatus {
    ASSESSMENT = 'ASSESSMENT',
    NOT_ASSIGNED = 'NOT_ASSIGNED',
    CLIENT_WITH_ISSUES = 'CLIENT_WITH_ISSUES',
    PROCESSING = 'PROCESSING',
    IN_REVIEW = 'IN_REVIEW',
    READY_FOR_SUBMISSION = 'READY_FOR_SUBMISSION',
    AWAITING_ITA = 'AWAITING_ITA',
    SUBMITTED = 'SUBMITTED',
    VISA_RESULTS = 'VISA_RESULTS',
    AWAITING_LOA = 'AWAITING_LOA',
    CLOSED = 'CLOSED',
    ON_HOLD = 'ON_HOLD',
    // applications with status removed will not be returned from the database
    REMOVED = 'REMOVED',
}
